<template>
  <div>
    <Table :columns="columns" :loading="dataLoading"  width="800" :data="administrators" :row-class-name="RowClassName">
      <template slot-scope="{ row }" slot="Name">
        <strong>{{ row.Name }}</strong>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="warning"
                size="small"
                style="margin-right: 5px"
                @click="update(row,index)"
        >Update</Button
        >
        <Button type="error" size="small" @click="remove(row)" v-if="administrators.length>1 && row.Email!==currentUserEmail" >Delete</Button>
      </template>
    </Table>
  </div>
</template>

<script>
  import {bus} from "../../main";
  import { getAdministrators,deleteAdministrator } from "../../_services/administrator.service";

  export default {
    data() {
      return {
        currentUserEmail: localStorage.getItem('user_email'),
        columns: [
          {
            title: "Name",
            slot: "Name"
          },
          {
            title: "Email",
            key: "Email"
          },
          {
            title: " ",
            slot: "action",
            width: 220,
            align: "center"
          }
        ],
        administrators: [],
        latestUpdated:null,
        dataLoading:true
      };
    },
    methods: {
      getAdministratorsList() {
        getAdministrators().then(async res => {
          this.administrators=res.data.data.reduce((newAdmins,admin)=>{
            if(admin.Email===this.currentUserEmail){
              newAdmins.unshift(admin)
            }else {
              newAdmins.push(admin)
            }
            return newAdmins
          },[])
          await this.$emit('setList',this.administrators)
          this.dataLoading = false
        }).catch(err => {
          this.dataLoading = false
          bus.$emit('requestError',err)
          this.$Message.error("Failed to get administrators. Please try again later.");

        });
      },
      RowClassName(row, index) {
        if (row.Email === this.currentUserEmail) {
          return 'active-admin-table-row';
        }
        return '';
      },
      remove: async function(data) {

        this.$Modal.confirm({
          title: 'Remove Administrator',
          content: `<p>Are you sure you want to remove <b>${data.Name}</b>?</p>`,
          okText: 'Remove',
          cancelText: 'Cancel',
          onOk: () => {
            this.dataLoading = true
            deleteAdministrator(data._id).then(res => {
              this.getAdministratorsList();
              this.dataLoading = false
              this.$Message.success(`Administrator ${data.Email} successfully deleted!`);
            }).catch(err => {
              this.dataLoading = false
                this.$Message.error("Failed to remove administrator. Please try again later.");
            });
          },
        });

      },
      update: async function(data,index) {
        this.latestUpdated=index
        this.$emit("update", data);
      }
    },
    mounted() {
      this.getAdministratorsList();
    }
  };
</script>
